import { ItemStatus } from "@/services/collection/item/collectionItemTypes";
import { revertMap } from "@/utilities/map";

export enum ItemStatusUrlString {
  InMyCollection = "collection",
  NotInCollection = "notInCollection",
  OnMarketplace = "marketplace",
  Deleted = "deleted",
  Expired = "expired",
  SoldOut = "sold",
}

export const ItemStatusToUrlString: Record<ItemStatus, ItemStatusUrlString> = {
  [ItemStatus.InMyCollection]: ItemStatusUrlString.InMyCollection,
  [ItemStatus.OnMarketplace]: ItemStatusUrlString.OnMarketplace,
  [ItemStatus.Deleted]: ItemStatusUrlString.Deleted,
  [ItemStatus.NotInCollection]: ItemStatusUrlString.NotInCollection,
  [ItemStatus.Expired]: ItemStatusUrlString.Expired,
  [ItemStatus.SoldOut]: ItemStatusUrlString.SoldOut,
};

export const UrlStringToItemStatus = revertMap(ItemStatusToUrlString);
